// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Cg","itemsContainer":"Dg"};